module.exports = __webpack_public_path__ + "54aaff4d1b17dd294e3b71ef9980b5b6.png";